export const LAYER_PANEL_CAPTION_SX = {
    display: 'block',
    fontSize: '0.8rem',
    lineHeight: 1.15,
    fontWeight: 400,
    color: 'text.secondary',
} as const;

export const LAYER_PANEL_EXPANDED_WIDTH = 344;
export const LAYER_PANEL_COLLAPSED_WIDTH = 56;
